export default {
  name: 'wisk-send-done',
  width: 15,
  height: 15,
  paths: [
    {
      d: 'M1.20307 1.04312C1.00481 0.954998 0.77234 1.0048 0.627577 1.16641C0.482813 1.32802 0.458794 1.56455 0.568116 1.75196L3.92115 7.50002L0.568116 13.2481C0.458794 13.4355 0.482813 13.672 0.627577 13.8336C0.77234 13.9952 1.00481 14.045 1.20307 13.9569L14.7031 7.95692C14.8836 7.87667 15 7.69761 15 7.50002C15 7.30242 14.8836 7.12336 14.7031 7.04311L1.20307 1.04312ZM4.84552 7.10002L2.21234 2.586L13.2689 7.50002L2.21234 12.414L4.84552 7.90002H9C9.22091 7.90002 9.4 7.72094 9.4 7.50002C9.4 7.27911 9.22091 7.10002 9 7.10002H4.84552Z'
    },
    {
      fill: '#52dbbc',
      transform: 'translate(10, 10) scale(0.17)',
      d: 'M17.5,35A17.5,17.5,0,1,1,35.0005,17.5005,17.52,17.52,0,0,1,17.5,35Zm0-32.7914A15.2914,15.2914,0,1,0,32.7919,17.5005,15.31,15.31,0,0,0,17.5,2.2086Z'
    },
    {
      fill: '#008465',
      transform: 'translate(1.1, 6.9) scale(0.6)',
      d: 'M25.2815,7.4844l-3.5623,3.9981-1.4429,1.6233a.8151.8151,0,0,1-1.2025.03l-1.5932-1.6534-1.3077-1.3678a.8263.8263,0,0,1-.0451-1.0972.6487.6487,0,0,1,.9921-.0451l2.42,2.51.1052.1052.09-.1052,4.5543-5.11a.6581.6581,0,0,1,.992,0A.8637.8637,0,0,1,25.2815,7.4844Z'
    }
  ]
}
